module.exports = __webpack_public_path__ + "img/open-with-rounded.c1c7e756.svg";